/**
 * 3D Model Viewer for collection pages.
 * Loads Google's <model-viewer> web component, reveals the 3D viewer on success,
 * and hides the original hero image. If model fails to load, original image remains.
 */
(function () {
  'use strict';

  var MODEL_VIEWER_SRC = 'https://unpkg.com/@google/model-viewer@3.5.0/dist/model-viewer.min.js';

  function revealSection(section) {
    if (section.classList.contains('is-loaded')) return;
    section.classList.add('is-loaded');

    // Hide the original float-right hero <img> in the description
    var description = section.closest('.collection-hero__description');
    if (description) {
      description.classList.add('has-3d-model');
    }
  }

  function initSection(section) {
    var viewer = section.querySelector('model-viewer');
    if (!viewer) return;

    viewer.addEventListener('load', function () {
      revealSection(section);
    });

    // Check if already loaded (race: cached module + cached model)
    if (viewer.loaded) {
      revealSection(section);
      return;
    }

    if (!customElements.get('model-viewer')) {
      customElements.whenDefined('model-viewer').then(function () {
        if (viewer.loaded) revealSection(section);
      });
    }
  }

  var sections = document.querySelectorAll('[data-model-section]');
  if (!sections.length) return;

  if (!customElements.get('model-viewer')) {
    var script = document.createElement('script');
    script.type = 'module';
    script.src = MODEL_VIEWER_SRC;
    document.head.appendChild(script);
  }

  sections.forEach(initSection);

  // Expand/collapse toggle
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-model-expand]');
    if (!btn) return;
    var section = btn.closest('[data-model-section]');
    if (!section) return;
    section.classList.toggle('is-expanded');
  });
})();
